/**
 * Aniversários na viagem (rodada 2, item 6).
 *
 * A data de nascimento é da conta e opcional. O que sai daqui é só "em que
 * dia DA VIAGEM cai o aniversário" — nunca o ano, nunca a idade. Um
 * aniversário de 29/02 numa viagem sem 29/02 cai em 28/02 (é o que as
 * pessoas fazem).
 */
import { addCalendarDays, type CalendarDate, diffCalendarDays, enumerateDays } from './calendar.js';

export interface PersonWithBirthDate {
  memberId: string;
  name: string;
  /** `YYYY-MM-DD` ou nulo. */
  birthDate: string | null;
}

export interface BirthdayInTrip {
  memberId: string;
  name: string;
  /** O dia da viagem em que cai. */
  date: CalendarDate;
}

const monthDay = (d: string) => d.slice(5);

export function birthdaysDuringTrip(people: readonly PersonWithBirthDate[], start: CalendarDate, end: CalendarDate): BirthdayInTrip[] {
  const dias = enumerateDays(start, end);
  const temBissexto = dias.some((d) => monthDay(d) === '02-29');
  const saida: BirthdayInTrip[] = [];
  for (const p of people) {
    if (!p.birthDate || !/^\d{4}-\d{2}-\d{2}$/.test(p.birthDate)) continue;
    let alvo = monthDay(p.birthDate);
    if (alvo === '02-29' && !temBissexto) alvo = '02-28';
    for (const d of dias) {
      if (monthDay(d) === alvo) saida.push({ memberId: p.memberId, name: p.name, date: d });
    }
  }
  return saida.sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : a.name.localeCompare(b.name, 'pt-BR')));
}

/** Quantos dias antes a Home começa a avisar. */
export const BIRTHDAY_NOTICE_DAYS = 3;

/**
 * O que a Home diz hoje: aniversários de hoje, e os que vêm nos próximos
 * `BIRTHDAY_NOTICE_DAYS` dias (com a distância). Passados, nada.
 */
export function upcomingBirthdays(list: readonly BirthdayInTrip[], today: CalendarDate, noticeDays = BIRTHDAY_NOTICE_DAYS): (BirthdayInTrip & { daysUntil: number })[] {
  const limite = addCalendarDays(today, noticeDays);
  return list
    .filter((b) => b.date >= today && b.date <= limite)
    .map((b) => ({ ...b, daysUntil: diffCalendarDays(b.date, today) }));
}
